import React from 'react'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { compose } from 'redux'

import InputText from '../../views/widgets/InputText'
import Field from '../../views/widgets/Field'
import Media from '../../views/layouts/Media'
import { initialValueForMultiLangSupport } from '../../../modules/form/index'
import config from '../../../config'
import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import withRemoveImage from '../image-edit/withRemoveImage'
import { removeLink } from '../../../actions/portal'
import withValidateBeforeSync from '../../../modules/common/withValidateBeforeSync'

export const LinkListItemForm = ({
  language = 'th',
  values,
  handleChange,
  handleBlur,
  handleAutoSyncOnBlur,
  onRemoveImage,
  errors,
}) => (
  <Media onRemove={onRemoveImage}>
    <Field label="ชื่อ">
      <InputText
        name={`title.${language}`}
        placeholder="Title"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.title[language]}
        error={errors.title ? errors.title[language] : null}
      />
    </Field>
    <Field label="รายละเอียด">
      <InputText
        name={`description.${language}`}
        placeholder="Description"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.description[language]}
      />
    </Field>
    <Field label="ลิงค์">
      <InputText
        name={`externalUrl`}
        placeholder="www.google.com"
        onChange={handleChange}
        onBlur={handleAutoSyncOnBlur}
        value={values.externalUrl}
        error={errors.externalUrl && errors.externalUrl[language]}
      />
    </Field>
  </Media>
)

const initialValues = link => ({
  title: initialValueForMultiLangSupport(config.supportedLanguages),
  description: initialValueForMultiLangSupport(config.supportedLanguages),
  externalUrl: '',
  ...link,
})

const validateLinkList = (values, { language = 'th' }) => {
  const errors = {}
  if (!values.title[language]) {
    errors.title = { th: 'หัวข้อ ต้องไม่มีค่าว่าง' }
  }
  if(values.externalUrl && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm.test(values.externalUrl)){
    errors.externalUrl = { th: 'รูปแบบ url ไม่ถูกต้อง' }
  }
  return errors
}

export const withListListItemForm = withFormik({
  mapPropsToValues: ({ link }) => {
    return initialValues(link)
  },
  validate: validateLinkList,
  enableReinitialize: true,
})

export default compose(
  connect(
    ({ info: { language }, portal: { _id: portalId } }) => ({
      language,
      portalId,
    }),
    (dispatch, { index }) => ({
      onRemoveLink: () => dispatch(removeLink(index)),
    }),
  ),
  withRemoveImage(props => ({
    imageId: props.link.mainImageId,
    onRemoveItem: props.onRemoveLink,
  })),
  withListListItemForm,
  withPortalAutoRemoteSync(props => {
    return { path: `links.${props.index}` }
  }),
  withValidateBeforeSync({
    validate: validateLinkList,
  }),
)(LinkListItemForm)



// WEBPACK FOOTER //
// ./src/components/templates/link-list/LinkListItemForm.js